"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LeftActionsSection = require("./LeftActionsSection");
Object.keys(_LeftActionsSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LeftActionsSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LeftActionsSection[key];
    }
  });
});
